"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FirstNetSignOnModelState = /** @class */ (function () {
    function FirstNetSignOnModelState() {
        this.isVerificationModalOpen = false;
        this.isVerificationFailure = false;
    }
    return FirstNetSignOnModelState;
}());
exports.default = FirstNetSignOnModelState;
//# sourceMappingURL=FirstNetSignOnModelState.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/CartConfigurationContainer/FirstNetSignOnModel/FirstNetSignOnModelState.js
// module id = 2355
// module chunks = 8